import './youtube.css';

type YouTubeEmbedProps = {
  videoId: string;
  title?: string;
};

/** Privacy-enhanced YouTube player for haul reports and other platform surfaces. */
export function YouTubeEmbed({ videoId, title = 'YouTube video' }: YouTubeEmbedProps) {
  if (!videoId) return null;
  return (
    <div className="youtube-embed">
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}`}
        title={title}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
}
